import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import { theme } from '../constants/theme';

interface PageWrapperProps {
  children: React.ReactNode;
  maxWidth?: string;
}

export function PageWrapper({ children, maxWidth = theme.layout.maxWidth }: PageWrapperProps) {
  return (
    <Box p={4} maxWidth={maxWidth} mx="auto">
      <Box
        bg={theme.colors.bg}
        borderRadius="lg"
        p={6}
        border="1px solid"
        borderColor={theme.colors.border}
      >
        <VStack align="stretch" gap={4}>
          {children}
        </VStack>
      </Box>
    </Box>
  );
}

export default PageWrapper;